import React from 'react'

import { Container, H1 } from './styledComponents'

export const NotFound = () => {
	return (
		<Container>
			<H1>Page Not Found</H1>
		</Container>
	)
}
